
/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      /* navigation js */
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '#ll-body' ).toggleClass( 'is-open-parent' );
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.children-item__children' ).on( 'toggleAfter', ( event ) => {
        updateMenuIndex( event.target );
        firstLinkFocus( event.target );
      } );

      /* ADA close the nav if you have tabbed outside it on mobile */
      const ctaLink = $( '.nav__cta-banner-link' );

      $( '#primary-nav' ).on( 'focusout', function( event ) {
        if ( event.relatedTarget === null || window.innerWidth > 1024 ) return;
        const reltarget = $( event.relatedTarget );
        const currenttarget = $( event.currentTarget );

        if ( !reltarget.closest( '#primary-nav' ).is( currenttarget ) && ( $( reltarget ).get( 0 ) !== $( '.navbar-toggle' ).get( 0 ) ) ) {
          $( '.navbar-toggle' ).trigger( 'click' );
        }
      } );

      $( '.primary-menu-item > button' ).on( 'toggleAfter', function( e ) {
        if ( window.innerWidth > 1023 ) {
          const menu = $( e.target ).attr( 'data-menu' );
          $( menu ).fadeToggle();
        }
      } );

      $( '.primary-nav .dropdown-menu li button' ).on( 'toggleAfter', function( e ) {
        if ( window.innerWidth > 1023 ) {
          const menu = $( e.target ).attr( 'data-menu' );
          $( menu ).fadeToggle( 250 );
        } else {
          const menu = $( e.target ).attr( 'data-menu' );
          $( menu ).slideToggle();
        }
      } );

      const updateBannerHeight = () => {
        if ( $( '.primary-nav-mobile-cta' ).length > 0 ) {
          const ctaBannerHeight = $( '.primary-nav-mobile-cta' ).outerHeight();
          document.documentElement.style.setProperty( '--ctaBannerHeight', `${ctaBannerHeight}px` );
        }
      };

      if ( window.matchMedia( '(max-width: 1024px)' ).matches ) {
        $( '.children-item__children.is-open-parent' ).trigger( 'click' );
      }

      function handleLargeChange( event ) {
        if ( event.matches ) {
          updateBannerHeight();
        }
        if ( !event.matches && ( $( '.children-item__children.is-open-parent' ).length === 0 ) ) {
          $( '.children-item__children[data-toggle-is-active]' ).trigger( 'click' );
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const largeSize = window.matchMedia( '(max-width: 1024px)' );
      largeSize.addEventListener( 'change', handleLargeChange );
      handleLargeChange( largeSize );

      /* end of navigation js */

      $( 'button.easy-toggle-slide-toggle' ).on( 'toggleAfter', function( event ) {
        const target = $( this ).data( 'toggle-target' );
        $( target ).slideToggle();
      } );

      document.querySelectorAll( '.single_add_to_cart_button, .button.wc-backward, button[name="update_cart"], .checkout-button, button.alt, #place_order, button[name="apply_coupon"]' ).forEach( ( btn ) => {
        if ( !btn.querySelector( 'span' ) && btn.tagName !== 'INPUT' ) {
          btn.innerHTML = `<span>${btn.textContent.trim()}</span>`;
        }
      } );

      $( document ).on( 'click', '.js-init-video, .wp-block-click-to-play a', function( e ) {
        e.preventDefault();

        let videoUrl = $( this ).attr( 'href' );
        let autoplayMatch = videoUrl?.match( /[?&]autoplay=([01])/ ) || ['autoplay=0'];
        autoplayMatch = autoplayMatch[0].replace( /[?&]/, '' );
        videoUrl = videoUrl.replace( /([?&])autoplay=[01](&|$)/, '$1' ).replace( /\?$/, '' );

        $.magnificPopup.open( {
          items: {
            src: videoUrl,
          },
          type: 'iframe',
          iframe: {
            markup: `
              <div class="mfp-iframe-scaler">
                <div class="mfp-close"></div>
                <iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>
              </div>
            `,
            patterns: {
              youtube: {
                index: 'youtube.com/',
                id: 'v=',
                src: `//www.youtube.com/embed/%id%?${autoplayMatch}`,
              },
              vimeo: {
                index: 'vimeo.com/',
                id: '/',
                src: `//player.vimeo.com/video/%id%?${autoplayMatch}`,
              },
              gmaps: {
                index: '//maps.google.',
                src: '%id%&output=embed',
              },
            },
            srcAction: 'iframe_src',
          },
          mainClass: 'mfp-fade',
          removalDelay: 160,
          preloader: false,
          fixedContentPos: false,
          callbacks: {
            open: function() {
              $( 'video' ).trigger( 'pause' );
            },
            close: function() {
              $( 'video' ).trigger( 'play' );
            },
          },
        } );
      } );

      /* allows File Upload input to update name when file is uploaded */
      if ( $( '.form-skin .ll-file-upload' ).length > 0 && typeof( gform ) !== 'undefined' ) {
        $( 'input[type=\'file\']' ).change( function() {
          const fullPath = $( this ).val();
          let filename = fullPath.replace( /^.*[\\/]/, '' );
          if ( filename === '' ) {
            filename = 'No file chosen';
          }
          const theInput = $( this ).parent().find( '.ll-file-upload .ll-file-details' );
          $( theInput ).text( filename );
        } );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      /* Set up arias for blog sidebar toggles */
      toggleBlogSidebarAriaVisibility();

      $( window ).on( 'resize', function() {
        toggleBlogSidebarAriaVisibility();
      } );

      function toggleBlogSidebarAriaVisibility() {
        if ( window.innerWidth > 1024 ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', false );
        } else if ( window.innerWidth <= 1024 && !$( '.blog__sidebar-inner' ).hasClass( 'is-open' ) ) {
          $( '.blog__sidebar-inner' ).attr( 'aria-hidden', true );
        }
      }

      if ( $( '.mec-breadcrumbs' ).length > 0 ) {
        const updateBreadCrumbHeight = function() {
          const $breadCrumbHeight = $( '.mec-breadcrumbs' ).outerHeight();
          $( ':root' ).css( '--liftedMecBreadCrumbHeight', $breadCrumbHeight + 'px' );
        };
        updateBreadCrumbHeight();
        const throttledUpdateBreadCrumbHeight = new app.components.common.Throttle( updateBreadCrumbHeight, 250 );
        $( window ).on( 'resize', function() {
          throttledUpdateBreadCrumbHeight.run();
        } );
      }

      /* ADA - make sure image link is not in tab index since we are using title like to make whole card clickable */
      $( '.mec-event-image a' ).each( function() {
        $( this ).attr( 'tabindex', -1 );
      } );
    },
    finalize: function() {
    },
    Throttle: class Throttle {
      constructor( callback, delay ) {
        this.callback = callback;
        this.delay = delay;
        this.throttlePause = false;
        this.waitingArgs = null;
        this.timeoutFunc = this.timeoutFunc.bind( this );
      }
      run( ...args ) {
        if ( this.throttlePause ) {
          this.waitingArgs = args;
          return;
        }
        this.callback( ...args );
        this.throttlePause = true; // Set throttle pause state for this instance
        setTimeout( this.timeoutFunc, this.delay );
      }
      timeoutFunc() {
        if ( this.waitingArgs ) {
          this.callback( ...this.waitingArgs );
          this.waitingArgs = null;
          setTimeout( this.timeoutFunc, this.delay );
        } else {
          this.throttlePause = false;
        }
      }
    },
    Debounce: class Debounce {
      constructor( callback, time ) {
        this.callback = callback;
        this.time = time;
        this.debounceTimer;
      }
      run() {
        window.clearTimeout( this.debounceTimer );
        this.debounceTimer = window.setTimeout( this.callback, this.time );
      }
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
